import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { toast } from "react-toastify";
import { imageExtentionSupport } from "../../utils/Helper";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { NotificationAddAction } from "../../Redux/Action/NotificationsAction";
import { FormattedMessage, useIntl } from "react-intl";




interface FormInputs {
  title: string,
  description: string,
  receiver:string
}
function NotificationAdd() {
  const dispatch = useDispatch<any>();
  const notificationAdd = useSelector((state: any) => state.NotificationAddState);
  const log_in = useSelector((state: any) => state.AdminLogInState)
  const navigate = useNavigate()
  const intl = useIntl();
  const formSchema: any = Yup.object().shape({
    title: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_title" }))
      .trim()
      .min(2, intl.formatMessage({ id: "title_min_length" }))
      .max(50, intl.formatMessage({ id: "title_max_length" })),
      receiver: Yup.string()
      .required(intl.formatMessage({ id: "please_select_user_type" }))
      .trim(),
    description: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_description" }))
      .trim()
      .min(20, intl.formatMessage({ id: "description_min_length" }))
      .max(300, intl.formatMessage({ id: "description_max_length" })),
  });

  const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
    resolver: yupResolver(formSchema),
  });

  const onSubmit = (data: FormInputs) => {
    dispatch(NotificationAddAction(data))
  };



  useEffect(() => {
    return () => {
      dispatch(NotificationAddAction('RESET'));
    }
  }, [])

  useEffect(() => {
    if (notificationAdd?.status) {
      navigate('/notifications')
    }
  }, [notificationAdd?.status])

  return (
    <Fragment>
      {log_in?.loading || notificationAdd.loading ? <Spinner /> : ""}
      <PageLayout
        title={intl.formatMessage({ id: "notification_add" })}
        breadcrumbs={{
          secLast: { 'link': '/notifications', 'name': intl.formatMessage({ id: "notification_management" }) },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >
        <div className="mt-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4 mb-4">
              <div className="col-md-6">
                <label htmlFor="username" className="form-label"><FormattedMessage id="title" />*</label>
                <input type="text" className="form-control mb-0" id="username" placeholder={intl.formatMessage({ id: "enter_title" })} {...register("title", {
                  required: intl.formatMessage({ id: "please_enter_title" }),

                })}
                />
                <ErrorMessage
                  errors={errors}
                  name="title"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="username" className="form-label"><FormattedMessage id="description" />*</label>
                <textarea className="form-control mb-0" id="username" placeholder={intl.formatMessage({ id: "enter_description" })} {...register("description", {
                  required: intl.formatMessage({ id: "please_enter_description" }),
                })}
                />
                <ErrorMessage
                  errors={errors}
                  name="description"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="status" className="form-label"><FormattedMessage id="user_type" />*</label>
                <select  id="approved" className="form-control profile-approve-dropdown" {...register("receiver")}  >
                <option value="">{intl.formatMessage({ id: "select_user_type" })}</option>
                  <option value="1"  >{intl.formatMessage({ id: "all_user" })}</option>
                  <option value="2" >{intl.formatMessage({ id: "all_customer_user" })}</option>
                  <option value="3" >{intl.formatMessage({ id: "all_salon" })}</option>
                </select>
                <ErrorMessage
                  errors={errors}
                  name="receiver"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-2" style={{marginTop:'52px'}}>
                <button type="submit" className="btn btn-primary waves-effect waves-light w-100"><FormattedMessage id="save_caps" /></button>
              </div>
            </div>

          </form>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}


export default NotificationAdd
